<template>
  <div>
    <!-- FGTS controls -->
    <b-row
      class="d-flex justify-content-between align-items-center bg-light py-3"
      style="border-bottom: 0.0625rem solid rgb(231, 234, 243)"
    >
      <b-col md="3">
        <b-form-checkbox switch size="sm" v-model="proposal.steps.fgts.actived"
          >FGTS</b-form-checkbox
        >
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.fgts.situation"
          :options="fgtsSituationOptions"
          v-if="proposal.steps.fgts.actived"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          size="sm"
          v-model="proposal.steps.fgts.status"
          v-if="fgtsStatusOptions[proposal.steps.fgts.situation]"
          :options="fgtsStatusOptions[proposal.steps.fgts.situation]"
        ></b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-datepicker
          size="sm"
          placeholder="Data de validade"
          locale="pt-BR"
          today-button
          reset-button
          close-button
          :date-format-options="{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }"
          v-model="proposal.steps.fgts.dueDate"
          v-if="proposal.steps.fgts.situation"
        >
        </b-form-datepicker>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col class="d-flex flex-column">
        <div>
          <div class="mb-4"><b>Dados da Operação do FGTS</b></div>
          <div class="d-flex justify-content-between">
            <small class="form-text text-muted mb-1">Nº da Operação</small>
            <img
              :src="
                pendingFgtsList.every((el) => el.notShow)
                  ? require('@/assets/img/card-checklist-green.svg')
                  : pendingFgtsList.every((el) => !el.notShow)
                  ? require('@/assets/img/card-checklist-red.svg')
                  : require('@/assets/img/card-checklist-yellow.svg')
              "
              alt="icon"
              width="30"
              height="30"
              class="pointer"
            />
          </div>
          <b-form-input
            size="sm"
            class="mb-2"
            v-model="proposal.operationNumber"
            v-mask="['#####-#-##-######-#']"
          ></b-form-input>
          <small class="form-text text-muted mb-1">Valor de FGTS</small>
          <currency-input
            ref="fgtsValue"
            class="mb-2 form-control form-control-sm"
            v-model="proposal.fgtsValue"
            currency="BRL"
            locale="pt"
            maxlength="9"
          />
        </div>
      </b-col>
      
      
      
      <b-col>
        <div class="mb-4"><b>Verificações necessária</b></div>
        <div v-for="(list, index) in pendingFgtsList" :key="index">
          <div
            class="
              userListItem
              d-flex
              justify-content-between
              align-items-center
            "
          >
            <div class="userListItemLabel">{{ list.item }}</div>
            <b-form-checkbox v-model="list.notShow"></b-form-checkbox>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { mask } from "vue-the-mask";
import { CurrencyInput } from "vue-currency-input";

var moment = require("moment");
moment.locale("pt-br");

var bootbox = require("bootbox");

export default {
  name: "ControlOfTheFgtsFlow",
  data() {
    return {
      array: "",
      /*showPendingFgtsDialog: false,*/
      fgtsSituationOptions: [
        {
          value: "",
          text: "Selecione a situação",
          color: "light",
          msg: "",
          progress: 0,
        },
        {
          value: "Cadastrado",
          text: "Cadastrado",
          color: "secondary",
          msg: "Operação de FGTS cadastrada para débito em",
          progress: 2,
        },
        {
          value: "Solicitado",
          text: "Solicitado",
          color: "",
          msg: "",
          progress: 0,
        },
      ],
      fgtsStatusOptions: {
        Solicitado: [
          {
            value: "",
            text: "Selecione o status",
            color: "light",
            msg: "",
            progress: 0,
          },
          {
            value: "Liberação de ressarcimento solicitada",
            text: "Liberação de ressarcimento solicitada em",
            color: "primary",
            msg: "Débito do FGTS aguardando ressarcimento",
            progress: 10,
          },
          {
            value: "Com erro",
            text: "Com erro",
            color: "danger",
            msg: "Operação de FGTS com exigência(s) em",
            progress: 5,
          },
          {
            value: "Ressarcida",
            text: "Ressarcida",
            color: "success",
            msg: "Operação de FGTS ressarcida em",
            progress: 15,
          },
        ],
      },
      pendingList: {
        handler: function (val) {
          Vue.set(this.proposal, "pendingList", val);
        },
        deep: true,
      },
      pendingFgtsList: [
        {
          item: "Autorização de FGTS no App.",
          subItem: "Solicitar autorização do cliente no app do FGTS.",
          notShow: false,
        },
        {
          item: "Extrato analítico.",
          subItem: "Solicitar extrato analítico a agência.",
          notShow: false,
        },
        {
          item: "Possui 36 meses de contribuição ao FGTS?",
          subItem:
            "Conferir se o cliente possuir no mínimo 36 meses de contribuição ao FGTS.",
          notShow: false,
        },
        {
          item: "Cliente não possui imóvel.",
          subItem: "Verifique se o cliente não possui imóvel.",
          notShow: false,
        },
        {
          item: "Declaração de IR com o respectivo recibo de entrega.",
          subItem:
            "Verifique se houve declaração de IR e recebimento do documento.",
          notShow: false,
        },
        {
          item: "Imóvel está situação no mesmo município de moradia/trabalho do cliente.",
          subItem:
            "Verifique se o imóvel objeto da operação pertence ao município que o cliente reside ou pretende trabalhar.",
          notShow: false,
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["setModificationNotification"]),
    ...mapActions(["getProposal"]),
  },
  computed: {
    ...mapState(["proposal", "user"]),
  },
  directives: {
    mask,
    // currency: CurrencyDirective
  },
  components: {
    CurrencyInput,
  },
  watch: {
    pendingFgtsList: {
      handler: function (val) {
        Vue.set(this.proposal, "pendingFgtsList", val);
      },
      deep: true,
    },
    proposal: {
      handler: function (val) {
        if (val.pendingList && val.pendingList.length) {
          this.pendingList = val.pendingList;
        } else if (
          !val.pendingList ||
          (val.pendingList && !val.pendingList.length)
        ) {
          Vue.set(this.proposal, "pendingList", this.pendingList);
        }
        if (val.pendingFgtsList && val.pendingFgtsList.length) {
          this.pendingFgtsList = val.pendingFgtsList;
        } else if (!val.pendingFgtsList) {
          Vue.set(this.proposal, "pendingFgtsList", this.pendingFgtsList);
        }
        if (this.proposal.participants && this.proposal.participants.length) {
          this.proposal.participants.forEach((element) => {
            if (!element.participantList) {
              element.participantList = JSON.parse(
                JSON.stringify(this.participantList)
              );
            }
          });
        }
        if (val.bidderList && val.bidderList.length) {
          this.bidderList = val.bidderList;
        } else if (!val.bidderList) {
          Vue.set(this.proposal, "bidderList", this.bidderList);
        }
      },
      immediate: true,
    },
    "proposal.steps.fgts.situation"(newVal, oldVal) {
      // if (oldVal && newVal !== oldVal) {
      //   this.proposal.steps.fgts.status = "";
      //   console.log(this.proposal.steps.fgts.status, 'this.proposal.steps.fgts.status');
      // }
      if (oldVal || !this.proposal.steps.fgts.dueDate) {
        var today = new Date();
        var fgtsDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.fgts.dueDate = fgtsDate;
      }
      if (newVal) {
        for (let key in this.fgtsSituationOptions) {
          if (newVal === this.fgtsSituationOptions[key].value) {
            this.proposal.steps.fgts.color =
              this.fgtsSituationOptions[key].color;
            this.proposal.steps.fgts.note = this.fgtsSituationOptions[key].msg;
            this.proposal.steps.fgts["progress"] =
              this.fgtsSituationOptions[key].progress;
          }
        }
      } else {
        this.proposal.steps.fgts.color = "light";
        this.proposal.steps.fgts.note = "";
        this.proposal.steps.fgts.progress = 0;
      }
    },
    "proposal.steps.fgts.status"(newVal, oldVal) {
      if (newVal) {
        let situationArr =
          this.fgtsStatusOptions[this.proposal.steps.fgts.situation];
        situationArr.forEach((situation) => {
          if (situation.value === newVal) {
            if (situation.color)
              this.proposal.steps.fgts.color = situation.color;
            if (situation.msg) this.proposal.steps.fgts.note = situation.msg;
            if (situation.progress)
              this.proposal.steps.fgts.progress = situation.progress;
          }
        });
      } else {
        for (let key in this.fgtsSituationOptions) {
          if (
            this.proposal.steps.fgts.situation ===
            this.fgtsSituationOptions[key].value
          ) {
            this.proposal.steps.fgts.color =
              this.fgtsSituationOptions[key].color;
            this.proposal.steps.fgts.note = this.fgtsSituationOptions[key].msg;
            this.proposal.steps.fgts.progress =
              this.fgtsSituationOptions[key].progress;
          }
        }
      }
      if (oldVal || !this.proposal.steps.fgts.dueDate) {
        var today = new Date();
        var fgtsDate = moment(today).format("YYYY-MM-DD");
        this.proposal.steps.fgts.dueDate = fgtsDate;
      }
    },
    "proposal.steps.fgts.actived"(newVal) {
      if (newVal === false) {
        this.proposal.steps.fgts["badgeColor"] = "light";
        this.proposal.steps.fgts["color"] = "light";
        this.proposal.steps.fgts["dueDate"] = "";
        this.proposal.steps.fgts["note"] = "";
        this.proposal.steps.fgts["situation"] = "";
        this.proposal.steps.fgts["status"] = "";
        this.proposal.steps.fgts["progress"] = 0;
      }
    },
  },
};
</script>